import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./appDetails.html";
import { generateBadgeTooltips, generateLocalizedBadge, getBadgeI18nFunction } from '~/modules/helpers/badgeHelper';
import { selectSupportFeatures } from '~/modules/helpers/selectSupportedFeatures';
import { i18nStore, WireI18n } from '~/modules/stores/i18nStore';
import { selectExtensionListing } from '~/modules/utilities/listing_utils';
import { printDateSimple } from '~/modules/utilities/time';
const LISTING_COMPONENT_KEYS = ['globalComponentsCount', 'appBuilderComponentsCount', 'cmtyBuilderComponentsCount'];
const PACKAGE_CONTENTS_KEYS = ['objectsCount', 'tabsCount', 'applicationsCount'];
const API_SOLUTIONS_TYPE = ['API/Salesforce Platform API', 'API/Marketing Cloud API', 'API/B2C Commerce API'];
const LISTINGS_API_AND_B2C_TYPES = ['b2c-commerce/package', 'b2c-commerce/api', 'salesforce-platform/api', 'marketing-cloud/api'];
class AppDetails extends LightningElement {
  constructor(...args) {
    super(...args);
    this.listing = void 0;
    // @ts-expect-error * Automated Type Error Fix
    this.supportFeaturesTitleLabel = null;
    // @ts-expect-error * Automated Type Error Fix
    this.listingDetailsLabels = null;
    // @ts-expect-error * Automated Type Error Fix
    this.appDetailsLabels = null;
  }
  i18nCallback(i18n) {
    this.appDetailsLabels = i18n.appDetails;
    this.supportFeaturesTitleLabel = i18n.listingDetails.supportedFeaturesGroup;
    this.listingDetailsLabels = i18n.listingDetails;
  }
  get i18nModule() {
    return i18nStore.getState().i18n;
  }

  //TODO This typecast makes a dangerous assumption that the type of the solution.solution is a Force_Solution_Package, but we are currently not sure if that will always be the case
  get solution() {
    return this.listing.solution?.solution;
  }
  get isAPISolution() {
    return API_SOLUTIONS_TYPE.includes(this.forceListing.appType);
  }
  get forceListing() {
    return selectExtensionListing(this.listing);
  }
  get rawListedOnDate() {
    return this.forceListing?.publishedDate ? new Date(this.forceListing.publishedDate) : null;
  }
  get rawLatestRelease() {
    return this.solution?.lastModifiedDate ? new Date(this.solution?.lastModifiedDate) : null;
  }
  get listedOn() {
    return printDateSimple(this.forceListing?.publishedDate);
  }
  get latestRelease() {
    return printDateSimple(this.solution?.lastModifiedDate);
  }
  get releaseDate() {
    if (!this.rawListedOnDate) {
      return this.latestRelease;
    }
    if (this.rawLatestRelease && this.rawLatestRelease < this.rawListedOnDate) {
      return this.listedOn;
    }
    return this.latestRelease;
  }
  getNumberOrEmptyString(val) {
    if (val || val === 0) {
      return val;
    }
    return '';
  }
  get version() {
    if (LISTINGS_API_AND_B2C_TYPES.includes(this.listing.technology)) {
      return '';
    }
    if (!this.solution) {
      return '';
    }
    // @ts-expect-error * Automated Type Error Fix
    const majorVersion = this.getNumberOrEmptyString(this.solution.version?.majorVersion);
    // @ts-expect-error * Automated Type Error Fix
    const minorVersion = this.getNumberOrEmptyString(this.solution.version?.minorVersion);
    // @ts-expect-error * Automated Type Error Fix
    const patchVersion = this.getNumberOrEmptyString(this.solution.version?.patchVersion);
    return this.solution.version ? `${this.solution.name}/${this.solution.version.versionName || ''} ${majorVersion}.${minorVersion}.${patchVersion}` : this.solution.name;
  }
  get packageContents() {
    if (this.solution?.manifest) {
      return PACKAGE_CONTENTS_KEYS.map(key => {
        const i18nFn = getBadgeI18nFunction(key);
        // @ts-expect-error * Automated Type Error Fix
        return generateLocalizedBadge(key, () => i18nFn({
          VALUE: this.solution.manifest[key]
        }));
      });
    }
    return [];
  }
  get lightningComponents() {
    if (this.solution?.manifest) {
      return LISTING_COMPONENT_KEYS.map(key => {
        const i18nFn = getBadgeI18nFunction(key);
        // @ts-expect-error * Automated Type Error Fix
        return generateLocalizedBadge(key, () => i18nFn({
          VALUE: this.solution.manifest[key]
        }));
      });
    }
    return [];
  }
  get languages() {
    const lenaguages = this.forceListing?.languages || [];
    return lenaguages.map(key => generateLocalizedBadge(key));
  }
  get supportedFeatures() {
    const supportedFeatures = selectSupportFeatures(this.listing);
    return supportedFeatures.map(key => generateLocalizedBadge(key));
  }
  get supportedFeaturesTooltip() {
    const supportedFeatures = selectSupportFeatures(this.listing);
    return generateBadgeTooltips(supportedFeatures, this.forceListing);
  }
  get packageContentTooltip() {
    return this.listingDetailsLabels.tooltipsText.packageContentsTooltip;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(AppDetails, {
  publicProps: {
    listing: {
      config: 0
    }
  },
  wire: {
    i18nCallback: {
      adapter: WireI18n,
      method: 1,
      config: function ($cmp) {
        return {};
      }
    }
  },
  fields: ["supportFeaturesTitleLabel", "listingDetailsLabels", "appDetailsLabels"]
});
const __lwc_component_class_internal = _registerComponent(AppDetails, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;